import { SUBSCRIPTION_TIERS } from "seneca-common/features/subscriptions/features/subscription-products/state";

export const PAYMENT_FAILED_ERROR_MESSAGE =
  "Sorry, something went wrong with your payment. You have not been charged. Please try again.";

export const PROMOTED_TIERS = [
  SUBSCRIPTION_TIERS.examBoost,
  SUBSCRIPTION_TIERS.aiAssistant,
  SUBSCRIPTION_TIERS.tutoring
];
